import {
  GET_STORIES,
  RESET_STORIES,
  DELETE_STORY,
  RECENT_STORIES,
  DELETED_RECENT_STORY,
} from "../_actions/types";

export const initialState = {
  payload: [],
  loaded: false,
  page: 1,
  recent: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_STORIES:
      return initialState;
    case GET_STORIES:
      let payload =
        state.page === 1
          ? action.payload
          : state.payload.concat(action.payload);
      return {
        ...state,
        payload: payload,
        loaded: true,
        page: action.loadMore ? state.page + 1 : 1,
        loadMore: action.loadMore,
      };
    case DELETE_STORY:
      return {
        ...state,
        payload: state.payload.filter((item) => {
          const storyId = item.content_id || item.id;

          return storyId !== action.payload;
        }),
      };
    case RECENT_STORIES:
      return {
        ...state,
        recent: action.payload,
      };
    case DELETED_RECENT_STORY:
      return {
        ...state,
        recent: {
          ...state.recent,
          results: state.recent.results.filter((item) => {
            const storyId = item.content_id || item.id;

            return storyId !== action.payload;
          }),
        },
      };
    default:
      return state;
  }
}
